import { render, staticRenderFns } from "./SearchResultsFilters.vue?vue&type=template&id=ed626dfa&"
import script from "./SearchResultsFilters.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultsFilters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports